var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBovine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3024",
    "data-name": "Group 3024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.37,
    height: 52.327,
    viewBox: "0 0 71.37 52.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3386",
    "data-name": "Path 3386",
    d: "M25.266,658.9a1.317,1.317,0,1,1-1.317,1.317A1.319,1.319,0,0,1,25.266,658.9Z",
    transform: "translate(-3.719 -638.771)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3387",
    "data-name": "Path 3387",
    d: "M23.852,659.563a1.234,1.234,0,0,1-1.232-1.18c-.183-4.212-4.38-4.62-10.289-4.738a33.826,33.826,0,0,1-4.312-.256c-6.149-.968-8.4-4.633-8.493-4.789a1.234,1.234,0,0,1-.079-1.106c1.511-3.63,4.733-6.071,9.319-7.057a12.189,12.189,0,0,1,7.643.926,7.872,7.872,0,0,0,4.407.632,1.234,1.234,0,0,1,.338,2.445,10.305,10.305,0,0,1-5.767-.83,9.738,9.738,0,0,0-6.1-.759c-3.528.759-5.968,2.426-7.267,4.96a7.793,7.793,0,0,0,1.126,1.034A11.549,11.549,0,0,0,8.4,650.952a32.332,32.332,0,0,0,3.977.226,27.274,27.274,0,0,1,7.94.928,7.327,7.327,0,0,1,3.288,2.112,6.534,6.534,0,0,1,1.477,4.058,1.234,1.234,0,0,1-1.179,1.286Z",
    transform: "translate(0.647 -635.451)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3388",
    "data-name": "Path 3388",
    d: "M20.216,650.046a2.931,2.931,0,0,1-1.764-.589,12.164,12.164,0,0,0-6.388-2.561,7.883,7.883,0,0,0-2.574.168,1.234,1.234,0,1,1-.721-2.36c.217-.067,5.393-1.578,11.17,2.783a.454.454,0,0,0,.361.083.448.448,0,0,0,.3-.206A13.325,13.325,0,0,1,21.544,646a1.234,1.234,0,0,1,1.913,1.559,11.036,11.036,0,0,0-.757,1.1,2.92,2.92,0,0,1-2.484,1.382Z",
    transform: "translate(-0.87 -636.198)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3389",
    "data-name": "Path 3389",
    d: "M38.755,690.815c-.651,0-1.3-.015-1.924-.045a10.429,10.429,0,0,1-9.654-7.959L25.722,676.8a22.071,22.071,0,0,1-3.515-6.021A28.935,28.935,0,0,1,20.376,658.4a1.234,1.234,0,1,1,2.454.262,25.65,25.65,0,0,0,.249,5.814,22.02,22.02,0,0,0,4.712,10.944,1.235,1.235,0,0,1,.261.511l1.524,6.3a8.009,8.009,0,0,0,7.372,6.074c.587.028,1.194.042,1.806.042a1.234,1.234,0,1,1,0,2.468Z",
    transform: "translate(-3.071 -638.488)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3390",
    "data-name": "Path 3390",
    d: "M35.334,671.815a1.234,1.234,0,0,1-1.234-1.234v-8.174a10,10,0,0,0-.781-4.025,5.563,5.563,0,0,0-.783-1.333l.008.009,1.815-1.672a10.671,10.671,0,0,1,2.208,7.021v8.174A1.234,1.234,0,0,1,35.334,671.815Z",
    transform: "translate(-5.242 -638.149)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1016",
    "data-name": "Line 1016",
    d: "M-.266,4.154A1.234,1.234,0,0,1-1.5,2.92V-.266A1.234,1.234,0,0,1-.266-1.5,1.234,1.234,0,0,1,.968-.266V2.92A1.234,1.234,0,0,1-.266,4.154Z",
    transform: "translate(35.95 44.494)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3392",
    "data-name": "Path 3392",
    d: "M56.07,659.563h-.055a1.234,1.234,0,0,1-1.179-1.286,6.535,6.535,0,0,1,1.477-4.058,7.328,7.328,0,0,1,3.288-2.112,27.278,27.278,0,0,1,7.939-.927,32.227,32.227,0,0,0,3.977-.226,11.551,11.551,0,0,0,5.26-2.108,7.793,7.793,0,0,0,1.126-1.034c-1.3-2.534-3.739-4.2-7.267-4.96a9.74,9.74,0,0,0-6.1.759,10.437,10.437,0,0,1-6.219.819,1.234,1.234,0,0,1,.44-2.428,7.983,7.983,0,0,0,4.757-.636,12.186,12.186,0,0,1,7.644-.926c4.585.986,7.808,3.427,9.319,7.057a1.234,1.234,0,0,1-.079,1.106c-.093.156-2.344,3.821-8.494,4.789a33.859,33.859,0,0,1-4.312.256c-5.908.117-10.1.525-10.288,4.737A1.234,1.234,0,0,1,56.07,659.563Z",
    transform: "translate(-9.199 -635.451)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3393",
    "data-name": "Path 3393",
    d: "M59.64,658.9a1.317,1.317,0,1,1-1.318,1.317A1.319,1.319,0,0,1,59.64,658.9Z",
    transform: "translate(-9.819 -638.771)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3394",
    "data-name": "Path 3394",
    d: "M61.841,650.046A2.889,2.889,0,0,1,61.3,650a2.925,2.925,0,0,1-1.946-1.332,11.225,11.225,0,0,0-.759-1.1A1.234,1.234,0,0,1,60.512,646a13.432,13.432,0,0,1,.944,1.364.448.448,0,0,0,.3.206.454.454,0,0,0,.361-.083c5.777-4.362,10.953-2.85,11.17-2.783l-.721,2.36.008,0a8.077,8.077,0,0,0-2.7-.16,12.151,12.151,0,0,0-6.269,2.551A2.93,2.93,0,0,1,61.841,650.046Z",
    transform: "translate(-9.819 -636.198)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3395",
    "data-name": "Path 3395",
    d: "M42.47,690.815a1.234,1.234,0,1,1,0-2.468c.613,0,1.221-.014,1.807-.042a8.007,8.007,0,0,0,7.373-6.074l1.524-6.3a1.235,1.235,0,0,1,.261-.511c5.932-6.952,4.972-16.66,4.961-16.758a1.234,1.234,0,1,1,2.454-.262,28.94,28.94,0,0,1-1.831,12.371A22.074,22.074,0,0,1,55.5,676.8l-1.456,6.016a10.428,10.428,0,0,1-9.654,7.959C43.769,690.8,43.122,690.815,42.47,690.815Z",
    transform: "translate(-6.787 -638.488)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3396",
    "data-name": "Path 3396",
    d: "M49.27,671.815a1.234,1.234,0,0,1-1.234-1.234v-8.174a10.671,10.671,0,0,1,2.208-7.021l1.815,1.672.008-.009a5.564,5.564,0,0,0-.783,1.333,10,10,0,0,0-.781,4.025v8.174A1.234,1.234,0,0,1,49.27,671.815Z",
    transform: "translate(-7.994 -638.149)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3397",
    "data-name": "Path 3397",
    d: "M41.421,687.622a1.234,1.234,0,0,1-1.231-1.154,4.55,4.55,0,0,0-1.484-1.136l-.064-.035a11.489,11.489,0,0,1-2.419-1.9,3.123,3.123,0,0,1-.645-3.443A3.187,3.187,0,0,1,38.518,678h5.805a3.187,3.187,0,0,1,2.94,1.953,3.123,3.123,0,0,1-.645,3.443,11.489,11.489,0,0,1-2.419,1.9l-.066.036a4.545,4.545,0,0,0-1.482,1.135A1.234,1.234,0,0,1,41.421,687.622Zm-1.559-4.47a9.4,9.4,0,0,1,1.224.775q.178.134.335.268.157-.134.335-.268a9.4,9.4,0,0,1,1.224-.775,9.02,9.02,0,0,0,1.871-1.475.679.679,0,0,0,.14-.762.7.7,0,0,0-.667-.444H38.518a.7.7,0,0,0-.667.444.679.679,0,0,0,.14.762A9.021,9.021,0,0,0,39.862,683.152Z",
    transform: "translate(-5.738 -642.159)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1017",
    "data-name": "Line 1017",
    d: "M-.266,4.154A1.234,1.234,0,0,1-1.5,2.92V-.266A1.234,1.234,0,0,1-.266-1.5,1.234,1.234,0,0,1,.968-.266V2.92A1.234,1.234,0,0,1-.266,4.154Z",
    transform: "translate(35.95 44.494)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3398",
    "data-name": "Path 3398",
    d: "M42.471,692.712a1.234,1.234,0,1,1,0-2.468,6.155,6.155,0,0,0,2.923-.609,2.652,2.652,0,0,0,.591-.412,1.234,1.234,0,1,1,1.966,1.491C47.8,690.919,46.324,692.712,42.471,692.712Z",
    transform: "translate(-6.788 -644.063)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3399",
    "data-name": "Path 3399",
    d: "M25.408,643.853a1.234,1.234,0,0,1-1.225-1.1,5.334,5.334,0,1,1,10.636-.585,1.234,1.234,0,0,1-2.468,0,2.867,2.867,0,1,0-5.716.313,1.234,1.234,0,0,1-1.09,1.362A1.194,1.194,0,0,1,25.408,643.853Z",
    transform: "translate(-3.754 -634.855)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3400",
    "data-name": "Path 3400",
    d: "M32.115,639.135a1.235,1.235,0,0,1-1.1-1.8,5.336,5.336,0,0,1,9.443-.122,1.234,1.234,0,1,1-2.168,1.179,2.869,2.869,0,0,0-5.077.064A1.234,1.234,0,0,1,32.115,639.135Z",
    transform: "translate(-4.95 -634.429)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3401",
    "data-name": "Path 3401",
    d: "M40.457,640.707c-.029,0-.058,0-.087,0a1.234,1.234,0,0,1-1.145-1.317,5.335,5.335,0,0,1,10.47-1.025,1.234,1.234,0,0,1-2.381.648,2.868,2.868,0,0,0-5.627.549A1.234,1.234,0,0,1,40.457,640.707Z",
    transform: "translate(-6.431 -634.428)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3402",
    "data-name": "Path 3402",
    d: "M57.329,643.719a1.235,1.235,0,0,1-1.191-1.558,2.867,2.867,0,1,0-5.634-.751,1.234,1.234,0,1,1-2.468,0,5.334,5.334,0,1,1,10.483,1.4A1.235,1.235,0,0,1,57.329,643.719Z",
    transform: "translate(-7.994 -634.72)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3403",
    "data-name": "Path 3403",
    d: "M42.789,646.423a3.83,3.83,0,0,1-1.5-.313,3.916,3.916,0,0,1-1.494-1.1,2.877,2.877,0,0,1-.7-1.831,1.234,1.234,0,1,1,2.468,0,1.075,1.075,0,0,0,.687.663,1.059,1.059,0,0,0,1.185-.14,1.234,1.234,0,0,1,1.712,1.777A3.377,3.377,0,0,1,42.789,646.423Z",
    transform: "translate(-6.408 -635.763)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3404",
    "data-name": "Path 3404",
    d: "M51.37,648.26a3.508,3.508,0,0,1-.84-.1,3.21,3.21,0,0,1-2.476-2.388,1.234,1.234,0,0,1,2.43-.428.969.969,0,0,0,.673.429c.38.081.547-.049.612-.135a1.234,1.234,0,0,1,1.954,1.507A2.926,2.926,0,0,1,51.37,648.26Z",
    transform: "translate(-7.994 -636.184)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBovine);
export default __webpack_public_path__ + "static/media/Bovine.ffd03b215ce8ac3b087824855965f0ae.svg";
export { ForwardRef as ReactComponent };